/* jshint esversion: 6 */
import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="attachment-preview"
// Shows a thumbnail/file-name preview of the selected attachment before sending.
export default class extends Controller {
  static targets = ['input', 'preview'];

  preview() {
    const file = this.inputTarget.files[0];

    if (!file) {
      this.clear();

      return;
    }

    this.previewTarget.classList.remove('d-none');

    if (file.type.startsWith('image/')) {
      const url = URL.createObjectURL(file);

      this.previewTarget.innerHTML = `
        <img src="${url}" alt="${this.escapeHtml(file.name)}"
             class="dm-attachment-thumbnail rounded" />
      `;
    } else {
      this.previewTarget.innerHTML = `
        <div class="dm-attachment-file d-flex align-items-center p-2 rounded">
          <span class="text-truncate">${this.escapeHtml(file.name)}</span>
        </div>
      `;
    }
  }

  clear() {
    this.previewTarget.classList.add('d-none');
    this.previewTarget.innerHTML = '';
  }

  escapeHtml(text) {
    const div = document.createElement('div');

    div.textContent = text;

    return div.innerHTML;
  }
}
